<template>
  <Layout>
    <div slot="content" class="card p-6">
      {{ $route.meta }}
    </div>
  </Layout>
</template>

<script>
import Layout from "@/components/layout/Layout.vue";

export default {
  components: { Layout },
  data: () => ({}),
  created() { },
  computed: {},
  methods: {},
}
</script>
